import * as React from 'react';
import { Balloon } from '@alifd/next';

export default function ShippingPrice ( props: { logistics: any; quantity: any; price: any; moq: any; i18n: any; id?: string; } ) {
  const { logistics,quantity,price,moq,i18n, id = 'wholesale-tansport-selector' } = props;
  
  const {
    cost,
    method,
    tradeTerm,
    handleClick,
    hasAliLogistics,
    shortMethod,
    discountLimit,
    originalCost,
    isEmpty,
  } = logistics;  

  return (
    <div className="express-item">
      <div className="item-left">
        {i18n['202107_detail_pc_ShippingFloor_ShippingTitle']}
      </div>
      <div className="item-right">
        {isEmpty === false ? (
          <div>
            {moq > quantity && (
              <span className="normal">
                {i18n['202107_detail_pc_ShippingFloor_LowestPrice']}
              </span>
            )}
            <span className="price">
              {cost || price.currencyRule.currencyPattern.replace( '{0}',0 )}
            </span>
          </div>
        ) : (
          i18n['rightAction.negotiated']
        )}
        <div>
          {tradeTerm === 'DDP' && (
            <span className="other">
              {i18n['202107_detail_pc_ShippingFloor_duty']}
            </span>
          )}
        </div>
        {discountLimit && originalCost && (
          <div>
            <span className="flag">{discountLimit}</span>
            <span className="underline">{originalCost}</span>
          </div>
        )}
        {isEmpty === false ? (
          <div className="name">
            <span>{shortMethod || method}</span>
            <a
              href="#"
              id={id}
              onClick={e => {
                e.preventDefault();
                handleClick();
              }}
            >
              {i18n['202107_detail_pc_ShippingFloor_ChangeMethod']}
            </a>
          </div>
        ) : (
          <div className="name">
            <a
              href="#"
              id="wholesale-tansport-selector"
              onClick={e => {
                e.preventDefault();
                handleClick();
              }}
            >
              {i18n['companyCardIntegrated.verifyTipLink']}
            </a>
          </div>
        )}
        {hasAliLogistics && (
          <div className="manage">
            <Balloon
              trigger={<span className="flag">
                <img src="https://s.alicdn.com/@img/imgextra/i3/O1CN01cXrdip1VGIQJNiP35_!!6000000002625-55-tps-287-28.svg" />
              </span>}
              align="br"
              alignEdge
              triggerType="hover"
              closable={false}
              style={{ width: 300 }}
            >
              {i18n['202107_detail_pc_ShippingFloor_hover']}
            </Balloon>
          </div>
        )}
      </div>
    </div>
  );
}
